import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/app.scss"
import { applyTheme, getTheme } from './utils/theme';

applyTheme(getTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch((err) => {
            console.log('SW register failed', err);
        });
    });
}
